import { useContext, useEffect, useState } from "react";
import { CenterBox, OnsiteProgress } from "../../customelements/CustomInput";
import { useLocation, useNavigate } from "react-router-dom";
import { TitleParamContext } from "../../context/TitleContext";
import { HttpPostData, JumpPage, GetDownloadFile } from "../../common/Util";
import { PageParam as BeforePageParam } from "../license/Paymentconfirm";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";

type ResponseParam = {
    list: TableRowType[]
}

type TableDataType = {
    list: TableRowType[]
}

export type TableRowType = {
    licenseKey: string,
    startLimit: string,
    endLimit: string,
}

export const PurchaseComplete = () => {

    const titleContext = useContext(TitleParamContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [dataList, setDataList] = useState<TableDataType>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDownLoad, setIsDownLoad] = useState<boolean>(false);
    const beforePageParam = location.state as BeforePageParam

    useEffect(() => {
        (async () => {
            titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "購入完了", secondSubTitle: "" });
            await HttpPostData<ResponseParam>("/License/GetPurchaseHistory", { PurchaseHistoryId: beforePageParam.list }, setIsLoading)
                .then((response) => {
                    setDataList({ list: response.data.list });
                })
                .catch(e => {
                    console.log(e);
                });
        })()
    }, [])

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    {isLoading ?
                        <CenterBox>
                            <OnsiteProgress></OnsiteProgress>
                        </CenterBox>
                        :
                        <>
                            <div className={base.flexCenterColumn}>
                                <div className={base.messageFont}>
                                    ご購入いただきありがとうございました。<br />
                                    下記ライセンスコードを、登録されているメールアドレス宛てに送付しました。<br/>
                                    ライセンスコードは、ライセンス設定手順書に従い ClickerAce に設定ください。<br />
                                    領収書はマイページの [ 領収書発行 ] よりダウンロードできます。<br />
                                </div>
                                <table className={base.pcTable} style={{ marginTop: "50px", marginBottom: "50px", width:"80%" }}>
                                    <thead>
                                        <th>ライセンスコード</th>
                                        <th>有効期間</th>
                                    </thead>
                                    <tbody>
                                        {dataList?.list.map((field, index) => {
                                            return (
                                                <tr>
                                                    <td>{field.licenseKey}</td>
                                                    <td>{field.startLimit}～{field.endLimit}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                        </>
                    }
                    <div className={market.mypageButtonMenu}>
                        <button className={market.myPageButton} disabled={isDownLoad}
                            onClick={(e) => GetDownloadFile("/UserManager/downloadinstallmanual", {}, setIsDownLoad)}
                        >ライセンス<br />設定手順書</button>
                        <button className={market.myPageButton} onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>マイページ</button>
                    </div>
                </div>
            </section>                      
        </>
    );
}

export const TrialComplete = () => {

    const titleContext = useContext(TitleParamContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [dataList, setDataList] = useState<TableDataType>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDownLoad, setIsDownLoad] = useState<boolean>(false);
    const beforePageParam = location.state as BeforePageParam

    useEffect(() => {
        (async () => {
            titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "お試しライセンス発行", secondSubTitle: "" });
            await HttpPostData<ResponseParam>("/License/GetPurchaseHistory", { PurchaseHistoryId: beforePageParam.list }, setIsLoading)
                .then((response) => {
                    setDataList({ list: response.data.list });
                })
                .catch(e => {
                    console.log(e);
                });
        })()
    }, [])

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    {isLoading ?
                        <CenterBox>
                            <OnsiteProgress></OnsiteProgress>
                        </CenterBox>
                        :
                        <>
                            <div className={base.flexCenterColumn}>
                                <div className={base.messageFont}>                                    
                                    お試し用のライセンスコードを、登録されているメールアドレス宛てに送付しました。<br />
                                    ライセンスコードは、ライセンス設定手順書に従い ClickerAce に設定ください。<br />                                    
                                </div>
                                <table className={base.pcTable} style={{ marginTop: "50px", marginBottom: "50px", width: "80%" }}>
                                    <thead>
                                        <th>ライセンスコード</th>
                                        <th>有効期間</th>
                                    </thead>
                                    <tbody>
                                        {dataList?.list.map((field, index) => {
                                            return (
                                                <tr>
                                                    <td>{field.licenseKey}</td>
                                                    <td>{field.startLimit}～{field.endLimit}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                        </>
                    }
                    <div className={market.mypageButtonMenu}>
                        <button className={market.myPageButton} disabled={isDownLoad}
                            onClick={(e) => GetDownloadFile("/UserManager/downloadinstallmanual", {}, setIsDownLoad)}
                        >ライセンス<br />設定手順書</button>
                        <button className={market.myPageButton} onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>マイページ</button>
                    </div>
                </div>
            </section>
        </>
    );
}